import CalculatorsController from '../../src/javascripts/cvm';
import Cadency from '../../src/javascripts/models/trintech/cadency';
import MarketoHelper from '../../src/javascripts/helpers/application/marketo_helper';
import '../../src/javascripts/helpers/application/currency_modal';
import '../../src/stylesheets/trintech/cadency.scss';

(function() {
  $(() => CalculatorsController.run(new Cadency()));
}).call(this);

$(() => {
  const marketo_helper = new MarketoHelper();
  marketo_helper.run();
});
